export const ActionTypes = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT: "LOGOUT",
  ADD_AVATAR: "ADD_AVATAR",
};
